var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-option-comp",attrs:{"data-active":_vm.active}},[_c('span',{staticClass:"letter"},[_vm._v(_vm._s(_vm.letters[_vm.position]))])])}
var staticRenderFns = []

export { render, staticRenderFns }